import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Currency } from '../../models/currency.model';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'lx-price-lists-portal-currency',
  templateUrl: './currency.component.html',
  styleUrls: ['./currency.component.scss', './print-currency.component.scss'],
})
export class CurrencyComponent {
  @Input() currency: Currency | undefined;
}
